<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $tc("add") }} {{ $tc("Movie", 1) }} {{ $tc("Resolution", 1) }}
      </div>
      <router-link class="btn-blue" to="movie-resolutions"
        >{{ $tc("Movie", 1) }} {{ $tc("Resolution", 1) }}
        {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in MovieResolution"
          :key="index"
          v-if="item.fieldname !== 'resolution_id'"
          class="col-lg-6 col-xl-3 align-self-center"
        >
          <div v-if="item.fieldname !== 'resolution_is_active'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  v-b-tooltip.hover.top="$t(item.tooltip)"
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t(item.tooltip)" /> -->
            </div>
            <p class="error_message">
              <!-- <span v-if="submitted && errors.has(item.fieldname)">{{
                errors.first(`${item.fieldname}`)
              }}</span> -->
              <span v-if="submitted && errors.has(item.fieldname)">
                {{ $tc(item.errormsg) }}</span
              >
            </p>
          </div>
          <div v-if="item.fieldname === 'resolution_is_active'">
            <div class="row">
              <div class="col-md-3 col-xl-2 align-self-center">
                <label class="mb-0">{{ $t("active") }}</label>
              </div>
              <div class="col-md-9 col-xl-10 align-self-center">
                <!-- <label class="ios-switch"> -->
                <b-form-checkbox
                  type="checkbox"
                  class="j-checkbox"
                  v-model="item.fieldvalue"
                />
                <!-- <span class="switch-slider"></span>
                </label> -->
              </div>
            </div>
            <p class="error_message"></p>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="handleSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="handleSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetHandler" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="movie-resolutions"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MovieResolution from "@/helper/formJSONMaster/MovieResolution";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      MovieResolution: MovieResolution.ms_movie_resolutions,
      // v-validate="'required|email'"
      submitted: false,
      Methods: MovieResolution.Methods,
    };
  },
  mounted() {
    this.resetHandler();
  },
  methods: {
    onFocusHandler: function () {},
    resetHandler: function () {
      this.MovieResolution.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    handleSubmit(flag) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.btenable = true;
          let body = this.getRequestBody(
            "POST",
            this.MovieResolution,
            this.Methods
          );
          console.log("body MovieResolution :", body);

          if (body.payload) {
            body.payload = {
              ...body.payload,
              resolution_is_active: body.payload.resolution_is_active
                ? "Y"
                : "N",
            };
          }

          MasterService.AddMovieResolution(body.payload)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                console.log("here :", data);
                if (flag) {
                  this.$router.push({
                    path: "movie-resolutions",
                  });
                } else {
                  this.resetHandler();
                }
              } else {
                this.$toasted.show(data.message);
                console.log("show error1 :", data.message);
              }
            })
            .catch((error) => {
              this.$toasted.show(error);
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/MovieResolutionComponent/AddMovieResolution.vue